import React, { useState } from "react";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import PageHeading from "../../../../components/admin/common/PageHeading";
import { IoIosSave } from "react-icons/io";

// Mocked available tasks (replace this with props or fetch from AddTask.js)
const mockAvailableTasks = [
  { id: 1, name: "Task 1", summary: "Introduction to Algebra" },
  { id: 2, name: "Task 2", summary: "Geometry Basics" },
  { id: 3, name: "Task 3", summary: "Data Handling" },
];

const AssignNewTask = () => {
  const [sessionType, setSessionType] = useState("individual");
  const [selectedTasks, setSelectedTasks] = useState([]);

  const handleTaskToggle = (taskId) => {
    setSelectedTasks((prev) =>
      prev.includes(taskId)
        ? prev.filter((id) => id !== taskId)
        : [...prev, taskId]
    );
  };

  return (
    <AdminAppBody
      content={
        <div className="container">
          <PageHeading
            title="Assign New Task"
            subTitle="Assign tasks/modules to individual students or groups"
          />

          <div className="card shadow-sm rounded mt-4">
            <div className="card-body">
              <form>
                {/* Row: Program | Selected Program */}
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Program</label>
                    <select className="form-select">
                      <option>Select Program</option>
                      <option>Math</option>
                      <option>Science</option>
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      Selected Program
                    </label>
                    <select className="form-select">
                      <option>Select</option>
                      <option>Algebra Module</option>
                      <option>Physics Module</option>
                    </select>
                  </div>
                </div>

                {/* Row: Module | Topic */}
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Module</label>
                    <select className="form-select">
                      <option>Select Module</option>
                      <option>Module 1</option>
                      <option>Module 2</option>
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Topic</label>
                    <select className="form-select">
                      <option>Select Topic</option>
                      <option>Topic A</option>
                      <option>Topic B</option>
                    </select>
                  </div>
                </div>

                {/* Available Tasks */}
                <div className="mb-4">
                  <label className="form-label fw-semibold">
                    Available Tasks
                  </label>
                  <div className="border rounded p-3 bg-light">
                    <button className="RVBtn mb-4">Select all</button>
                    {mockAvailableTasks.map((task) => (
                      <div className="form-check mb-2" key={task.id}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={`task-${task.id}`}
                          checked={selectedTasks.includes(task.id)}
                          onChange={() => handleTaskToggle(task.id)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`task-${task.id}`}
                        >
                          <strong>{task.name}</strong> —{" "}
                          <small>{task.summary}</small>
                        </label>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Due Date (Half Row) */}
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Due Date</label>
                    <input type="date" className="form-control" />
                  </div>
                </div>

                {/* Session Type (Full Row) */}
                <div className="row mb-3">
                  <div className="col-12">
                    <label className="form-label fw-semibold d-block">
                      Session Type
                    </label>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="sessionType"
                        id="individual"
                        value="individual"
                        checked={sessionType === "individual"}
                        onChange={() => setSessionType("individual")}
                      />
                      <label className="form-check-label" htmlFor="individual">
                        Individual
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="sessionType"
                        id="group"
                        value="group"
                        checked={sessionType === "group"}
                        onChange={() => setSessionType("group")}
                      />
                      <label className="form-check-label" htmlFor="group">
                        Group
                      </label>
                    </div>
                  </div>
                </div>

                {/* Select Student / Group (Full Row) */}
                <div className="row mb-4">
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      {sessionType === "individual"
                        ? "Select Student"
                        : "Select Group"}
                    </label>
                    <select className="form-select">
                      <option>
                        {sessionType === "individual"
                          ? "Choose a student"
                          : "Choose a group"}
                      </option>
                      <option>
                        {sessionType === "individual" ? "John Doe" : "Group A"}
                      </option>
                      <option>
                        {sessionType === "individual"
                          ? "Jane Smith"
                          : "Group B"}
                      </option>
                    </select>
                  </div>
                </div>

                {/* Save Button */}
                <div className="text-end">
                  <button type="submit" className="btn btn-success">
                    Assign Task
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default AssignNewTask;
